import { OnDestroy } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RowNode, SelectionChangedEvent } from 'ag-grid-community';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { CustomGridService } from '../../../../customgrid';
import { BObjectModel, InputModel, QResult, QueovalDik, Select } from '../../../../models';
import { GenericEffectif } from '../../../../models/effectif/genericEffectif.model';
import { ModeEffectif, Option } from '../../../../models/effectif/option.model';
import { CertificationApprenant, CertificationIdent, StageDocumentUpdate } from '../../../../models/formation';
import { CoreService, HttpService } from '../../../../services';
import { StageService } from '../services/stage-modal.service';



@Component({
  selector: 'queoval-stage-certification',
  templateUrl: './certification.component.html',
  styleUrls: ['./certification.component.css']
})
/** Composant qui affiche les bilans (par rapport au stage et au apprenants) dans une grid,
 * on peut également créer des bilans pour les apprenants
 */
export class CertificationComponent implements OnInit, OnDestroy {

  // #region CONSTRUCTEUR
  constructor(
    private http: HttpService,
    private indParam: CoreService,
    public service: StageService,
    protected customgridservice: CustomGridService,
    private modalService: NgbModal
  ) { }
  // #endregion

  @Input('refreshGrid') set SetRefreshGrid(value: boolean) {
    if (value) {
      this.refreshData = value;
      setTimeout(() => { this.refreshGridChange.emit(false); }, 250);
    }

  }
  @Output() refreshGridChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  // #region variables globales
  public fileNameForGrid: string;

  public codeVisuGrid: string;
  /* bo à afficher dans la grid */
  public boModel: BObjectModel;
  /* bo à afficher dans la grid */
  public boModelBilan: CertificationApprenant;
  /* lignes selectionnees dans la grid */
  public selectedNodes: RowNode[];

  public validateBo: boolean = false;
  public refreshData: boolean;
  //verrouille le bouton de génération des bilans quand true
  public isTrainingProgressReportLocked: boolean = true;

  // Liste des types de bilan (pour affichage)
  public listTypesBilan: Array<Select>;

  public gridObserver: Subscription;
  /* modal ou ouvrir le bo*/
  @ViewChild('ModalBo') ModalBo: TemplateRef<HTMLTemplateElement>;
  /* modal ou ouvrir le bo bilan*/
  @ViewChild('ModalCreateBoBilan') ModalCreateBoBilan: TemplateRef<HTMLTemplateElement>;
  /* modal de création d'objectifs pédagogiques*/
  @ViewChild('ModalCreateObjectifs') ModalCreateObjectifs: TemplateRef<HTMLTemplateElement>;
  /* modal ou suppression du bo bilan*/
  @ViewChild('ModalDeleteValidation') ModalDeleteValidation: TemplateRef<HTMLTemplateElement>;
  /* option envoyés au composant effectif*/
  public OptionStagiaire: Option;
  // #endregion

  //#region CYCLE DE VIE
  public ngOnInit(): void {
    this.validateBo = false;
    this.boModelBilan = new CertificationApprenant();
    this.boModelBilan.BoPosition = new BObjectModel();
    this.boModelBilan.BoPosition.IdDonneePere = this.service.Stage.Ident;
    this.boModelBilan.BoPosition.IdDonneeFils = "0";
    this.boModelBilan.BoPosition.CodeRelation = "REL_BO_STAGE_BO_POSITION";
    // Valeurs par défaut
    this.boModelBilan.BoPosition.NameBO = "BO_POSITION";
    this.boModelBilan.BoPosition.IdentBO = "BO_POSITION";
    this.fileNameForGrid = "ListeBilanCertification";
    this.codeVisuGrid = "";
    this.boModelBilan.BoPosition.DefaultInputs = [];
    this.service.GetObjectifPedagogique().subscribe(res => {
      const objPedago: InputModel = new InputModel();
      objPedago.id = 'ObjPeENT';
      objPedago.value = !res.Value ? '' : res.Value.split('\n').map(obj => { return '|' + obj }).join('\n');
      this.boModelBilan.BoPosition.DefaultInputs.push(objPedago);
      this.isTrainingProgressReportLocked = false;
    });

    this.OptionStagiaire = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.STAGIAIREMAIL);

    // Récupération des valeur auto de la propriété TyBilENT
    this.service.GetTypesBilan().subscribe(res => {
      this.listTypesBilan = res.Value;
    });

    this.InitGrid();
  }

  public ngOnDestroy(): void {
    this.gridObserver.unsubscribe();
  }
  //#endregion

  // #region FONCTIONS PUBLIQUES
  /**
   * lance la création du BO pour chaque apprenants
   * @param pBoModel Objet qui stock les infos du BO position
   * @param modalBO modal recu
   */
  public CreateBoPosition(pBoModel: BObjectModel, modalBO: any = null): void {
    this.validateBo = false;
    this.boModelBilan.IdStage = this.service.Stage.Ident;
    this.boModelBilan.BoPosition = pBoModel;
    this.http.postHttp<QResult<Array<CertificationApprenant>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Certification/CREATE_CERTIFICATION`, this.boModelBilan).subscribe(
      (result: QResult<Array<CertificationApprenant>>) => {
        //this.getEvent(this.modalBoBilan)
        //la grid se recharge au changement du nom du fichier
        this.UpdateGrid();
        modalBO.close();
      });
  }
  /**
   * permet de mettre a jour la liste des effectifs (coche/décoche)
   * @param effectifs tableau d'effectifs (output composant effectif)
   */
  public UpdateListEffectif(effectifs: Array<GenericEffectif>): void {
    const ids: string[] = effectifs.filter(effectif => effectif.IsSelected).map(effectif => effectif.Id);
    if (this.boModelBilan.Apprenants == undefined) {
      this.boModelBilan.Apprenants = [];
    }
    this.boModelBilan.Apprenants = ids;
  }

  /**
   * Ouverture de la modale de création de bilan / objectifs pédagogiques
   */
  public OpenModalCreationBilan(): void {
    // Si on est sur le BO_POSI_OBJPEDA
    if (this.boModelBilan.BoPosition.NameBO == 'BO_POSI_OBJPEDA') {
      this.modalService.open(this.ModalCreateObjectifs, { size: 'q-xxl', centered: true, windowClass: 'qmodalover' }).result.then(() => {
      });
    }
    else {
      // Récupération des propriétés du stage à charger pour l'initialisation du bilan (BO)
      this.service.GetPropertyStageForBilan().subscribe(res => {
        this.boModelBilan.BoPosition.DefaultInputs = [...res.Value];
        this.modalService.open(this.ModalCreateBoBilan, { size: 'q-xxl', centered: true, windowClass: 'qmodalover modal-create-bo-bilan' }).result.then(() => {
        });
      });
      
    }

  }

  public OpenModalDeleteValidation(): void {
    this.modalService.open(this.ModalDeleteValidation, { centered: true, windowClass: 'qmodalover modal-delete-bo-bilan' }).result.then(() => {
    });
  }


  /**
  * raffraichit la grid quand la modal est fermée
  * @param modalBo modal qui affiche le bo
  */
  public getEvent(modalBo: any = null): void {
    if (modalBo) {
      modalBo.close();
    }
  }

  public onAfterSaveBo(boObjet: BObjectModel, modalBo: any = null): void {

    // Update de la certification (CACES)
    let certification: CertificationIdent = new CertificationIdent();
    certification.IdApprenant = boObjet.IdDonneePere;
    certification.IdPosition = boObjet.IdDonneeFils;
    certification.IdStage = this.service.Stage.Ident;
    certification.CodeBoPosition = boObjet.NameBO;
    this.http.postHttp<QResult<Array<CertificationApprenant>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Certification/UPDATE_CERTIFICATION`, certification).subscribe(
      (result: QResult<Array<CertificationApprenant>>) => {
        //la grid se recharge au changement du nom du fichier
        //this.refreshGrid();
        this.UpdateGrid();

        if (modalBo) {
          modalBo.close();
        }
      });
  }

  public UpdateGrid(): void {
    //la grid se recharge au changement du nom du fichier
    this.fileNameForGrid = "";
    this.boModelBilan.BoPosition.NameBO = this.codeVisuGrid;
    // On met le code BO dans Ident BO pour l'affichage du BO choisi
    this.boModelBilan.BoPosition.IdentBO = this.codeVisuGrid;
    setTimeout(() => {
      this.fileNameForGrid = `ListeBilanCertification${this.codeVisuGrid}`;
      // Recharge la nouvelle grid
      if (this.gridObserver)
        this.gridObserver.unsubscribe();
      this.InitGrid();
    }, 1);
   
  }

  /**
   * Evénement après la génération des bilans pédagogiques
   * @param modalBo
   */
  EventAfterBilanGenerate(modalBo: any = null): void {
 
    // fermeture de la modale
    if (modalBo) {
      modalBo.close();
    }

    // Recharge la nouvelle grid
    this.UpdateGrid()
  }

  /**
   * Enregistrement d'une valeur modifiée dans la customgrid
   * @param e
   */
  saveValueChanged(e: any) {
    const colName = e.colDef.field;
    const value = e.source ? e.source : e.value;
    const ident = e.node.data.Ident;
    //code BO_POSITION par défaut sinon le code sélectionné
    let codeBO = this.codeVisuGrid != '' ? this.codeVisuGrid : 'BO_POSITION';

    const data: Array<QueovalDik> = Array<QueovalDik>();
    data.push(new QueovalDik(colName, value));

    this.http.patchHttp<QResult<string>>(`${this.indParam.AppParams.apiUrl}api/Stage/Certification/${codeBO}/${ident}`, data).subscribe();
  };


  //#endregion

  // #region FONCTIONS PRIVES
  /**
   * Initialise la grid 
   * */
  private InitGrid(): void {

    this.gridObserver = this.customgridservice.getItem(this.fileNameForGrid).subscribe((res: BObjectModel) => {
      switch (res.Action) {

        case 'ANG_PAGE':
          if (res.IdDonneeFils && res.IdDonneeFils != '0') {

            this.boModel = res;
            this.boModel.ShowSaveButton = true;
            const objPedago: InputModel = new InputModel();
            objPedago.id = 'ObjPeENT';
            objPedago.value = !this.service.ObjectifPedagogique ? '' : this.service.ObjectifPedagogique.split('\n').map(obj => { return '|' + obj }).join('\n');
            this.boModel.DefaultInputs = [objPedago];
            this.modalService.open(this.ModalBo, { size: 'q-xxl', centered: true, windowClass: 'qmodalover modal-bo' }).result.then((modalResult) => {
            });
          }
          break;
      }
    });
  }


  //#endregion


  /* 
  * Permet de recharger la grid
  */
  public refreshGrid(): void {
    this.refreshGridChange.emit(true);
  }

  /*
  * Permet d'avoir les lignes selectionnées
  */
  public selectLine(event: SelectionChangedEvent) {
    this.selectedNodes = event.api.getSelectedNodes();
  }


  public OnValidateBo(): void {
    this.validateBo = true;
  }

  public OnAfterValidateBo(message: string): void {
    setTimeout(() => { this.validateBo = false; }, 1);
  }

  /*
  * Supprimer les certifications selectionnés
  */
  public deleteSelection() {
    let documentModel: StageDocumentUpdate = new StageDocumentUpdate();
    documentModel.DocumentIdentList = new Array<string>();
    this.selectedNodes.forEach((document) => {
      documentModel.DocumentIdentList.push(document.data.Ident)
    });
    documentModel.StringData = this.service.Stage.Ident;

    this.http.postHttp<QResult<Array<CertificationApprenant>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Certification/DELETE_CERTIFICATION`, documentModel).subscribe(
      (result: QResult<Array<CertificationApprenant>>) => {
        //la grid se recharge au changement du nom du fichier
        //this.refreshGrid();
        this.UpdateGrid();
      });

  }
}
